export const findLicensedCps = (assignedLicenseSystemOfCurrentUser) => {

    const licensedColorProofSystemIds = assignedLicenseSystemOfCurrentUser
        .filter(ls => ls.licensed && ls.cpId)
        .map(ls => ls.cpId);

    return Array.from(new Set(licensedColorProofSystemIds));
};
